import moment from 'moment'
// MMSS 转 秒
// export const mmss2second = (mmss) => {
//   const [mm, ss] = mmss.split(':')
//   return
// }

// 计算开始结束时间间隔 s
export const s2eTimecountdown = (start, end) => {
  start = moment(start, "hh:mm")
  end = moment(end, "hh:mm")
  let timecount
  if (start > end) {
    timecount = 24 * 3600 + end.diff(start, 's')
  } else {
    timecount = end.diff(start, 's')
  }
  return timecount
}

// 计算直播开始时间
/**
 *
 * @param {timecountdown} 距离原始开课时间间隔
 * @param {s_time} 开课时间
 * @param {e_time} 结束时间
 * @param {after_in_class} 开课可进教室延时
 * @param {pre_in_class} 提前进教室时长
 *  return
 * 3 已开课 限制进教室
 * 2 未开始
 * 1 等待进教室
 * 0 进教室
 * -1 已结束
 */
export const enterStatus = ({
  timecountdown,
  s_time,
  e_time,
  after_in_class,
  pre_in_class
}) => {
  let timecount = s2eTimecountdown(s_time, e_time)
  if (+timecountdown > 0) {
    if (+timecountdown > 1 * 3600) {
      // 大于一天  未开始
      return 2
    } else {
      return (+timecountdown - +pre_in_class*60) > 0 ? 1 : 0
    }
  } else {
    if (+after_in_class === 0) {
      // 原始开课时间
      if (Math.abs(timecountdown) < timecount) {
        // 已开课时间在时间范围内
        // 可以进教室
        return 0
      } else if (Math.abs(+timecountdown) > timecount) {
        // 已开课时间 大于 时间范围
        return -1
      }
    } else {
      return Math.abs(timecountdown) > after_in_class * 60 ? 3 : 0
    }
  }
}
